import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

interface Payload {
  pointId: string
  date: string
}

export const reverseGeocodeBreadcrumbPoint = createAsyncThunk<
  void,
  // Type of first argument
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/breadcrumb/reverseGeocodePoint', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/breadcrumb/reverseGeocodePoint', {
      category: 'rpc',
      type: 'rpc/breadcrumb/reverseGeocodePoint',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {reverseGeocodePoint}`,
      { tags: ['rpc', 'breadcrumb'], info: { payload: payload, error } },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `ReverseGeocodePoint breadcrumb failed`,
      error,
    })
  }
})
